/**
 * @prettier
 */
import abacusUtil from '../../utils/abacus';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {compose} from 'redux';
import React, {Component} from 'react';
import {withApollo} from 'react-apollo';
import routes, {ROOT, ROOT2, RECENT_DETAILS, TRIPBOARD} from '../../routes';
import {getCurrentBoardId} from '../../tripboard/selectors';
import {getTranslations} from '../../selectors';
import recentActivityActions from '../../recent-activity/actions';
import tabSync from '../../utils/tab-sync';
import {
    PAGINATED_TRIPBOARDS_QUERY,
    queryParams
} from '../../tripboard/components/tripboards';
import {query as DETAILS_QUERY} from '../../tripboard/details/components/with-tripboard-query';
import ErrorPage from '../error-page';
import Feedback from '@homeaway/react-feedback';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import MainPage from '../MainPage/MainPageContainer';
import IntlWrapper from '../intl/intl-wrapper';
import NotFound from '../not-found';
import withAuth from '../auth/with-auth';
import {RecentActivityDetails} from '../../recent-activity';
import onboardingActions from '../onboarding/actions';
import {
    STARTED_KEY,
    COMPLETED_KEY,
    ONBOARDED_KEY
} from '../onboarding/middleware';
import {readFromStorage} from '../../utils/local-storage';
import {Switch, Route, withRouter} from 'react-router-dom';
import {Toaster} from '@homeaway/react-toaster';
import {TripboardDetailsPage} from '../../tripboard';
import withAbacusTestValuesAsProps from '../../abacus/with-abacus-test-values-as-props';
import {
    HA_PULSE_SHARED_TRIPBOARD_AB_TEST,
    WATERFALL_AB
} from '../../abacus/experiments';
// Abacus: waterfall
import {AsyncSvgs} from '../../abacus/waterfall';

import './App.less';
import '../../less/index.less';

function mapStateToProps(state) {
    const {footer, system} = state;
    const boardId = getCurrentBoardId(state);
    const translations = getTranslations(state);

    const lingua = {
        tabText: translations['shared.stabFeedback.tabText'],
        title: translations['shared.stabFeedback.title'],
        reviewLink: translations['shared.stabFeedback.reviewLink'],
        reviewLinkText:
            translations['shared.stabFeedback.lookingToWriteReview'],
        helpLink: translations['shared.stabFeedback.helpLink'],
        helpLinkText: translations['shared.stabFeedback.lookingForSupport'],
        supportLinkText: translations['shared.stabFeedback.leaveComment']
    };

    return {
        boardId,
        footer,
        siteName: system.siteName,
        currency: system.currency,
        fullLocale: system.fullLocale,
        lingua
    };
}
const mapDispatchToProps = {
    fetchRecentActivity: recentActivityActions.fetchRecentActivity,
    initOnboardingFlags: onboardingActions.initOnboardingFlags
};
class App extends Component {
    static defaultProps = {
        sharedTestValue: 0,
        waterfallTestValue: 0
    };

    constructor(props) {
        super(props);
    }

    componentDidMount = () => {
        const {initOnboardingFlags} = this.props;
        // Initialize abacus client utils and experiment cache
        abacusUtil.initialize();
        tabSync.setVisibilityListener(this.handleVisibilityChange);
        const startedTripboardCreation = readFromStorage(STARTED_KEY) || false;
        const completedTripboardCreation =
            readFromStorage(COMPLETED_KEY) || false;
        const onboardingCompleted = readFromStorage(ONBOARDED_KEY) || false;
        initOnboardingFlags(
            startedTripboardCreation,
            completedTripboardCreation,
            onboardingCompleted
        );
    };

    componentWillUnmount = () => {
        tabSync.removeVisibilityListener(this.handleVisibilityChange);
    };

    handleVisibilityChange = () => {
        if (!document.hidden) {
            // the handler fires twice for hidden = false and hidden = true.  We only need one.
            const {
                fetchRecentActivity,
                client,
                boardId,
                hav,
                currency,
                location: {pathname}
            } = this.props;

            if (pathname === ROOT || pathname === ROOT2) {
                fetchRecentActivity();
                client
                    .query({
                        query: PAGINATED_TRIPBOARDS_QUERY,
                        fetchPolicy: 'network-only',
                        errorPolicy: 'all',
                        variables: queryParams(hav)
                    })
                    .catch(/* silent swallow errors */);
            } else if (pathname.indexOf(TRIPBOARD) !== -1) {
                client
                    .query({
                        query: DETAILS_QUERY,
                        fetchPolicy: 'network-only',
                        errorPolicy: 'all',
                        variables: {
                            hav,
                            tripBoardUuid: boardId,
                            currency
                        }
                    })
                    .catch(/* silent swallow errors */);
            } else if (pathname.indexOf(RECENT_DETAILS) !== -1) {
                fetchRecentActivity();
            }
        }
    };

    render() {
        const {
            footer,
            lingua,
            siteName,
            fullLocale,
            sharedTestValue,
            waterfallTestValue
        } = this.props;

        // Start Abacus: ha_pulse_shared_tripboard_ab_test
        const appContainerClass = classnames(
            'app-page-container container-fluid',
            {
                'padding-bottom': sharedTestValue === 0
            }
        );

        // Abacus: waterfall
        const isWaterFallTestOn = waterfallTestValue > 0;

        return (
            <IntlWrapper>
                <div>
                    <Header />
                    <div className={appContainerClass} id="app-page-container">
                        <Switch>
                            <Route
                                exact
                                path={routes.TRIPBOARD}
                                component={MainPage}
                            />
                            <Route
                                exact
                                path={routes.TRIPBOARD_ERROR}
                                component={ErrorPage}
                            />
                            <Route
                                exact
                                path={routes.TRIPBOARD_DETAILS}
                                component={TripboardDetailsPage}
                            />
                            <Route
                                exact
                                path={routes.TRIPBOARD_MARKETING}
                                component={TripboardDetailsPage}
                            />
                            <Route
                                exact
                                path={routes.RECENT_DETAILS}
                                component={RecentActivityDetails}
                            />
                            <Route component={NotFound} />
                        </Switch>
                    </div>
                    <Toaster />
                    <Footer data={footer} site={siteName} locale={fullLocale} />
                    <div className={'app-page-container__hide-feedback-mobile'}>
                        <Feedback tabPosition={'right'} lingua={lingua} />
                    </div>

                    {/* Abacus: waterfall */}
                    {isWaterFallTestOn && <AsyncSvgs />}
                </div>
            </IntlWrapper>
        );
    }
}

export default compose(
    withRouter,
    withAuth,
    withAbacusTestValuesAsProps({
        [HA_PULSE_SHARED_TRIPBOARD_AB_TEST]: 'sharedTestValue',
        [WATERFALL_AB]: 'waterfallTestValue'
    }),
    withApollo,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(App);



// WEBPACK FOOTER //
// ./src/universal/components/App/App.js